import { when, reaction } from 'mobx';
import { types, getParent, getSnapshot, applySnapshot, destroy } from 'mobx-state-tree';
import cuid from 'cuid';
import dayjs from 'dayjs'

import DateTime from './date';

export const ExtraSearch = types
  .model("ExtraSearch", {
    id: types.optional(types.identifier, () => cuid()),
    userid: types.optional(types.maybeNull(types.string), null),
    subscription: types.optional(types.maybeNull(types.string), null),
    numberofsearches: types.optional(types.integer, 0),
    createdat: types.optional(DateTime, null),
    updatedat: types.optional(DateTime, null),
    deletedat: types.optional(DateTime, null),
  })
  .actions(self => ({
    setProp(prop, value) {
      self[prop] = value;
    },
    update(props) {
      const snap = getSnapshot(self);
      const record = Object.assign(
        {},
        snap,
        props
      );
      applySnapshot(self, record);
    },
    delete() {
      self.deletedat = dayjs().valueOf();
    },
    remove() {
      getParent(self, 2).remove(self);
    }
  })
);

export const ExtraSearches = types
  .model("ExtraSearches", {
    records: types.array(ExtraSearch),
  })
  .actions(self => ({
    add(record) {
      let r = self.records.find(r => r.id === record.id);
      if (!r) {
        self.records.push(record);
        r = self.records[self.records.length - 1];
      }
      return r;
    },
    update(record) {
      let r = self.records.find(r => r.id === record.id);
      if (r) {
        r.remove();
      }
      self.records.push(record);
      return record;
    },
    remove(record) {
      destroy(record);
    },
    clear() {
      self.records.clear();
    },
  })
);